import React, { Fragment } from 'react'
import { withRouter } from 'react-router-dom'
import SolicitudesComponent from './SolicitudesComponent';
import TabSolicitudesComponent from './TabSolicitudesComponent';
import { Tab, Tabs } from "@mui/material";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import estilos from "../../UsuarioInspectorEnCampo/Asociados/Tabs/TabsInspeccionarComponent.module.css";
import {
    DataGrid,
    GridToolbarQuickFilter,
    GridToolbarFilterButton,
} from "@mui/x-data-grid";
import Box from "@mui/material/Box";
import SolicitudesFC09Component from './SolicitudesFC09Component';
import { useDispatch } from 'react-redux';
import { obtenerTodasLasSolicitudesWithStatusEnviado } from '../../../redux/AtencionAClienteDucks';
import { getAllSolicitudesACUI } from '../../../redux/DucksUnidadInspeccion/SolicitudesUIF01Duck';
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import AssignmentIcon from '@mui/icons-material/Assignment';
import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn';
import GroupAddIcon from '@mui/icons-material/GroupAdd';
import SolicitudFC01UIComponent from './Formatos/SolicitudFC01UIComponent';
import SolicitudFC09UIComponent from './Formatos/SolicitudFC09UIComponent';
function QuickSearchToolbar() {
    return (
        <Box
            sx={{ p: 0.5, pb: 0, mb: 2, textAlign: 'left', height: 30, width: '100%', backgroundColor: 'white', textAlign: 'end' }}>
            <GridToolbarQuickFilter style={{ width: '25%', }} placeholder='Búsqueda...' />
        </Box>
    );
}
function PanelSolicitudes(props) {
    const dispatch = useDispatch();
    const [solicitudes, setSolicitudes] = React.useState([]);
    console.log(solicitudes)
    const [value, setValue] = React.useState("fc_01_solicitudderegistro");
    const handleChange = (event, newValue) => {
        setValue(newValue);
    };
    
    React.useEffect(() => {
        /*dispatch(getAllSolicitudesACUI({ status: 4, tipo: 'fc_01_solicitudderegistro' })).then(
            (res) => {
                setSolicitudes(res?.payload?.data?.data);
            }
        );*/
        /*dispatch(obtenerTodasLasSolicitudesWithStatusEnviado({ status: 4})).then(
            (res) => {
                setSolicitudes(res?.data?.data);
            }
        );*/
    }, []);

    return (
        <Fragment><br />
            <h3 style={{ textAlign: "center", fontWeight: "bold" }}>SOLICITUDES</h3>
            <Box className="text-center mt-2">
                <TabContext value={value}>
                    <Box
                        sx={{
                            borderBottom: 1,
                            borderColor: "divider",
                            backgroundColor: "white",
                            borderRadius: "2rem",
                            //marginLeft: "15%",
                            width: "100%",
                        }} className="center" >
                        <TabList
                            onChange={handleChange}
                            aria-label="lab API tabs example"
                            variant="scrollable"
                            scrollButtons="auto"
                            sx={{
                                "& button": {
                                    color: "black",
                                    borderRadius: "2rem",
                                    width: "20%",
                                    transition: "all 0.3s ease",
                                },
                                "& button:hover, & button.Mui-selected": {
                                    transform: "scale(1.1)",
                                },
                                "& button.Mui-selected": {
                                    backgroundColor: "rgb(14, 129, 60)",
                                    color: "white",
                                    fontSize: "15pt",
                                },
                            }}>
                            <Tab label="FC_01" value="fc_01_solicitudderegistro" />
                            <Tab label="FC_09" value="fc_09_solicitudemicioncertificadonomexportacionyentregahologram" />
                            <Tab label="FC_31" value="fc_31_solicitudseguimiento" />
                            <Tab label="FC_33" value="fc_33_solicitudenvasadonacional" />
                            <Tab label="FC_34" value="fc_34_notificacionsuspencionyreactivacion" />
                            <Tab label="FC_35" value="fc_35_notificaciondeserviciosvarios" />
                            <Tab label="FC_36" value="fc_36_solicituddeactualizacion" />
                            <Tab label="FC_41" value="fc_41_solicitudparabebidasconmezcal" />
                        </TabList>
                    </Box>
                    <TabPanel value="fc_01_solicitudderegistro">
                        <SolicitudFC01UIComponent value={value}/>
                        {/*<SolicitudesComponent></SolicitudesComponent>*/}
                    </TabPanel>
                    <TabPanel value="fc_09_solicitudemicioncertificadonomexportacionyentregahologram">
                        <SolicitudFC09UIComponent value={value}/>
                        {/*<SolicitudesFC09Component
                            solicitudes={
                                solicitudes?.fc_09_solicitudemicioncertificadonomexportacionyentregahologram
                            }
                            tipo={9}
                        />*/}
                    </TabPanel>
                    <TabPanel value="fc_31_solicitudseguimiento">
                        {/*<SolicitudesFC09Component
                solicitudes={solicitudes.fc_31_solicitudseguimiento}
                tipo={31}
              />*/}
                    </TabPanel>
                    <TabPanel value="fc_33_solicitudenvasadonacional">
                        {/*<SolicitudesFC09Component
                solicitudes={solicitudes.fc_33_solicitudenvasadonacional}
                tipo={30}
              />*/}
                    </TabPanel>
                    <TabPanel value="fc_34_notificacionsuspencionyreactivacion">
                        {/*<SolicitudesFC09Component
                solicitudes={
                  solicitudes.fc_34_notificacionsuspencionyreactivacion
                }
                tipo={34}
              />*/}
                    </TabPanel>
                    <TabPanel value="fc_35_notificaciondeserviciosvarios">
                        {/*<SolicitudesFC09Component
                solicitudes={solicitudes.fc_35_notificaciondeserviciosvarios}
                tipo={35}
              />*/}
                    </TabPanel>
                    <TabPanel value="fc_36_solicituddeactualizacion">
                        {/*<SolicitudesFC09Component
                solicitudes={solicitudes.fc_36_solicituddeactualizacion}
                tipo={36}
              />*/}
                    </TabPanel>
                    <TabPanel value="fc_41_solicitudparabebidasconmezcal">
                        {/*<SolicitudesFC09Component
                solicitudes={solicitudes.fc_41_solicitudparabebidasconmezcal}
                tipo={41}
              />*/}
                    </TabPanel>
                </TabContext>
            </Box>
        </Fragment>
    );
};


export default withRouter(PanelSolicitudes)
